/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload': {
    width: 209,
    height: 209,
    viewBox: '0 0 209 209',
    data: '<defs/><path pid="0" id="upload" class="cls-1" d="M1742.85 837a72.714 72.714 0 0 0-67.27 44.448 51.623 51.623 0 0 0-16.33-2.648 52.25 52.25 0 0 0-10.45 103.444v-21.773a31.268 31.268 0 1 1 27.36-55.745 10.447 10.447 0 0 0 15.84-6.414 52.2 52.2 0 1 1 82.2 53.373v24.456A73.088 73.088 0 0 0 1742.85 837zm17.84 128.462l-49.19-49.189-49.19 49.189 14.78 14.776 23.96-23.961V1046h20.9v-89.723l23.96 23.961z" transform="translate(-1607 -837)"/>'
  }
})
